import { hero } from "../data/siteData";
import "./Hero.css";

export default function Hero() {
  return (
    <section className="hero">
      <div className="hero__blob hero__blob--1" />
      <div className="hero__blob hero__blob--2" />
      <div className="hero__dots" />

      {/* Left — Text */}
      <div className="hero__content">
        <div className="hero__eyebrow">
          <span className="hero__eyebrow-dot" />
          {hero.eyebrow}
        </div>

        <h1 className="hero__heading">
          {hero.heading[0]}&nbsp;<strong>{hero.heading[1]}</strong>
          <br />
          <em>{hero.heading[2]}</em>
          <br />
          <strong>{hero.heading[3]}</strong>
        </h1>

        <p className="hero__desc">{hero.description}</p>

        <div className="hero__actions">
          <a href="#products" className="btn-primary">Explore Products</a>
          <a href="#science" className="btn-outline">Our Science →</a>
        </div>

        <div className="hero__trust">
          {["🌿 Eco Certified", "✅ USDA Registered", "🔬 10yr R&D"].map((t) => (
            <div className="hero__trust-item" key={t}>
              <span>{t}</span>
            </div>
          ))}
        </div>

        <div className="hero__stats">
          {hero.stats.map((s) => (
            <div key={s.label}>
              <div className="hero__stat-num">{s.num}</div>
              <div className="hero__stat-label">{s.label}</div>
            </div>
          ))}
        </div>
      </div>

      {/* Right — Visual */}
      <div className="hero__visual">
        <div className="hero__molecule">
          <div className="hero__mol-ring hero__mol-ring--1" />
          <div className="hero__mol-ring hero__mol-ring--2" />
          <div className="hero__mol-ring hero__mol-ring--3" />
          <div className="hero__mol-center">
            <span className="hero__mol-icon">🌿</span>
            <span className="hero__mol-text">Active<br />Ingredients</span>
          </div>
          {["🐛","🌾","🍄","💧","⚗️","🛡️"].map((e, i) => (
            <div className="hero__mol-node" key={i} style={{ "--i": i }}><span>{e}</span></div>
          ))}
        </div>

        {hero.badges.map((b, i) => (
          <div className={`hero__badge hero__badge--${i + 1}`} key={b.title}>
            <span className="hero__badge-icon">{b.icon}</span>
            <div>
              <div className="hero__badge-title">{b.title}</div>
              <div className="hero__badge-sub">{b.sub}</div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
